export default __webpack_public_path__ + "static/Speakeasylogo-ec61cd07a77b1e991daad7b88e45393f.jpeg";